import { IOrganisationConfig } from 'fitbeat.models';

const DEFAULT_PRIMARY_COLOR = '#ff5a1f';

export const MEMBERS_ANALYTICS_POWERED_BY_SRC = 'resources/images/PoweredByFitillion.svg';

export interface IMembersAnalyticsBranding {
  logoUrl?: string;
  primaryColor: string;
}

export function getMembersAnalyticsBranding(
  organisationConfig?: IOrganisationConfig | null,
): IMembersAnalyticsBranding {
  const theme = organisationConfig?.theme;
  return {
    logoUrl: theme?.logoUrl ?? theme?.iconUrl,
    primaryColor: theme?.colors?.PRIMARY ?? DEFAULT_PRIMARY_COLOR,
  };
}
